import { initializeApp } from "firebase/app";
import { firebaseConfig } from "./apiConfig";
import { getDatabase, ref, set, push, get, onValue, remove, child } from "firebase/database";
import { v4 as uuidv4 } from "uuid";

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

const setHistoryImageData = (urlList) => {
  const historyRef = ref(db, "history");
  urlList.forEach(({ imageUrl }) => {
    push(historyRef, {
      id: uuidv4(),
      url: imageUrl,
      date: new Date().toISOString(),
    });
  });
};

const deleteHistoryImageDataByURL = async (imageUrl) => {
  const historyRef = ref(db, "history");

  try {
    // Fetch all history data
    const snapshot = await get(historyRef);
    if (snapshot.exists()) {
      const data = snapshot.val();
      // Find the entry key that matches the given URL
      const entryKey = Object.keys(data).find((key) => data[key].url === imageUrl);

      if (entryKey) {
        // Remove the matching entry
        await remove(child(historyRef, entryKey));
        console.log(`Image with URL ${imageUrl} deleted successfully`);
      } else {
        console.log(`No image found with URL ${imageUrl}`);
      }
    } else {
      console.log("No history data found.");
    }
  } catch (error) {
    console.error("Error deleting image:", error);
  }
};

const getHistoryImageData = (setImageList) => {
  const historyRef = ref(db, "history");
  onValue(historyRef, (snapshot) => {
    const data = snapshot.val();
    if (data) {
      const sortedData = Object.values(data).sort((a, b) => new Date(b.date) - new Date(a.date));
      const imageList = sortedData.map((item) => ({ src: item.url }));
      setImageList(imageList);
    } else {
      setImageList([]);
    }
  });
};

const setPromptRequestToFirebase = (promptRequest) => {
  const promptRequestRef = ref(db, "prompt request");
  set(promptRequestRef, promptRequest);
};

const getPromptRequestFromFirebase = (dispatch, setPromptRequest) => {
  const promptRequestRef = ref(db, "prompt request");
  return get(promptRequestRef).then((snapshot) => {
    const data = snapshot.val();
    console.log("Get prompt request data:", data, data.model);
    dispatch(setPromptRequest(data));
    return data.model;
  });
};

export { setHistoryImageData, getHistoryImageData, deleteHistoryImageDataByURL, setPromptRequestToFirebase, getPromptRequestFromFirebase };
